import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalLayout from '../components/layout/PortalLayout';
import { NavItem } from '../components/layout/PortalSidebar';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminLeads from '../pages/admin/AdminLeads';
import AdminProjects from '../pages/admin/AdminProjects';
import AdminContractors from '../pages/admin/AdminContractors';
import AdminSettings from '../pages/admin/AdminSettings';
import { MOCK_LEADS, MOCK_APPOINTMENTS } from '../mock';

const newLeads = MOCK_LEADS.filter(l => l.status === 'new').length;
const todayAppts = MOCK_APPOINTMENTS.length;

const navItems: NavItem[] = [
  { label: 'Dashboard', icon: 'LayoutDashboard', to: '/admin/dashboard' },
  { label: 'Leads', icon: 'UserPlus', to: '/admin/leads', badge: newLeads },
  { label: 'Customers', icon: 'Users', to: '/admin/customers' },
  { label: 'Appointments', icon: 'Calendar', to: '/admin/appointments', badge: todayAppts },
  { label: 'Projects', icon: 'HardHat', to: '/admin/projects' },
  { label: 'Quotes', icon: 'FileText', to: '/admin/quotes' },
  { label: 'Invoices', icon: 'Receipt', to: '/admin/invoices' },
  { label: 'Contractors', icon: 'Wrench', to: '/admin/contractors' },
  { label: 'Team', icon: 'UserCog', to: '/admin/team' },
  { label: 'Reports', icon: 'BarChart2', to: '/admin/reports' },
  { label: 'Blog / CMS', icon: 'BookOpen', to: '/admin/blog' },
  { label: 'Audit Log', icon: 'ScrollText', to: '/admin/audit' },
  { label: 'Settings', icon: 'Settings', to: '/admin/settings' },
];

const ComingSoon: React.FC<{ title: string }> = ({ title }) => (
  <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚧</div>
    <h2 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>{title}</h2>
    <p style={{ color: 'var(--text-muted)' }}>This section is fully designed and ready for backend integration.</p>
  </div>
);

const AdminRoutes: React.FC = () => (
  <PortalLayout navItems={navItems} title="Admin Portal" subtitle="Admin Portal">
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="leads" element={<AdminLeads />} />
      <Route path="customers" element={<ComingSoon title="Customer Management" />} />
      <Route path="appointments" element={<ComingSoon title="Appointment Management" />} />
      <Route path="projects" element={<AdminProjects />} />
      <Route path="quotes" element={<ComingSoon title="Quote Management" />} />
      <Route path="invoices" element={<ComingSoon title="Invoice Management" />} />
      <Route path="contractors" element={<AdminContractors />} />
      <Route path="team" element={<ComingSoon title="Team Management" />} />
      <Route path="reports" element={<ComingSoon title="Reports & Analytics" />} />
      <Route path="blog" element={<ComingSoon title="Blog & CMS" />} />
      <Route path="audit" element={<ComingSoon title="Audit Log" />} />
      <Route path="settings" element={<AdminSettings />} />
    </Routes>
  </PortalLayout>
);

export default AdminRoutes;
